import classNames from 'classnames/bind';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from '@client/components/icons/icon/Icon';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './notification.scss';

const DISPLAY_TIME_MS = 4000;
const NOTIFICATION_HEIGHT = 50;
const NOTIFICATION_SPACING = 20;

export const NOTIFICATION_TYPE = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
};

const Notification = ({ notification, index, onDelete }) => {
  const positionBasedOnIndex =
    index * (NOTIFICATION_HEIGHT + NOTIFICATION_SPACING);

  useEffect(() => {
    const displayTimer = setTimeout(() => {
      onDelete();
      clearTimeout(displayTimer);
    }, DISPLAY_TIME_MS);
    return () => clearTimeout(displayTimer);
  }, []);

  const classFallback =
    notification.notificationType === '' || !notification.notificationType;
  const classSuccess =
    notification.notificationType === NOTIFICATION_TYPE.SUCCESS;
  const classWarning =
    notification.notificationType === NOTIFICATION_TYPE.WARNING;

  return (
    <div
      className={classNames({
        [styles.notis]: true,
        [styleHelper.text8]: true,
        [styles.default]: classFallback,
        [styles.success]: classSuccess,
        [styles.warning]: classWarning,
      })}
      style={{
        transform: `translate(-50%, ${-positionBasedOnIndex}px)`,
        animationDuration: `${DISPLAY_TIME_MS + 0.2}ms`,
        height: `${NOTIFICATION_HEIGHT}px`,
      }}
    >
      {notification.message}
      <Icon
        buttonClassName={classNames(styleHelper.text84, styles.clearBtn)}
        onClick={onDelete}
        iconClassName={classNames(styleHelper.iconcross, styles.icon)}
      />
    </div>
  );
};

Notification.propTypes = {
  notification: PropTypes.object,
  index: PropTypes.number,
  onDelete: PropTypes.func,
};

export default Notification;
